import { Price } from '@kanda-libs/ks-design-library';
import useJobFinanceBankingSubsidy from './useJobFinanceBankingSubsidy';

const JobFinanceBankingSubsidy: React.FunctionComponent = function () {
  const { cardPayment, subsidy, payout } = useJobFinanceBankingSubsidy();
  return (
    <>
      <div className="col-span-2 border-b border-neutral-300 my-2" />
      <p className="my-auto whitespace-nowrap">Payment:</p>
      <Price
        amount={cardPayment}
        color="neutral-700"
        poundsClassName="text-16-20-em"
        centsClassName="text-16-20-em"
        className="ml-auto"
      />
      <p className="my-auto whitespace-nowrap">Payment Subsidy:</p>
      <div className="flex flex-row justify-end my-auto">
        <p className="text-neutral-800 my-auto">-</p>
        <Price
          amount={subsidy}
          color="neutral-700"
          poundsClassName="text-16-20-em"
          centsClassName="text-16-20-em"
          className="ml-auto"
        />
      </div>
      <div className="col-span-2 border-b border-neutral-300 my-2" />
      <p className="my-auto">Payout:</p>
      <Price
        amount={payout}
        color="purple-500"
        poundsClassName="text-16-20-em"
        centsClassName="text-16-20-em"
        className="ml-auto"
      />
    </>
  );
};

export default JobFinanceBankingSubsidy;
